(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kultfrau-responsive-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kf-responsive-video')) {
    customElements.define('kf-responsive-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        if (!this.video || !this.button) return;
        this.sources = JSON.parse(this.querySelector('[data-kf-video-sources]').textContent);
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.mobile = matchMedia('(max-width: 767px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.auto = this.dataset.autoplay === 'true';
        this.userPaused = false;
        this.manual = false;
        this.visible = false;
        this.failed = false;
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.addEventListener('playing', () => {
          if (this.video.currentSrc !== this.source?.url) return;
          this.setAttribute('data-ready', '');
          this.setPlaying(true);
        }, options);
        this.video.addEventListener('pause', () => this.setPlaying(false), options);
        this.video.addEventListener('error', () => {
          if (!this.video.getAttribute('src')) return;
          this.failed = true;
          this.removeAttribute('data-ready');
          this.setPlaying(false);
          this.button.hidden = true;
        }, options);
        this.button.addEventListener('click', () => {
          if (!this.video.paused) {
            this.userPaused = true;
            this.video.pause();
          } else {
            this.userPaused = false;
            this.manual = true;
            this.start();
          }
        }, options);
        this.mobile.addEventListener('change', () => this.selectSource(), options);
        this.reduced.addEventListener('change', () => {
          if (this.reduced.matches) {
            this.manual = false;
            this.video.pause();
          }
          this.sync();
        }, options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.selectSource();
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.sync();
        }, { threshold: 0 });
        this.observer.observe(this);
      }

      selectSource() {
        const choices = (this.mobile.matches ? this.sources.mobile : this.sources.desktop) || [];
        const mp4 = choices.filter(source => source.mime_type === 'video/mp4' || source.format === 'mp4');
        const limit = this.mobile.matches ? 1080 : 2160;
        const withinLimit = mp4.filter(source => source.width <= limit);
        const sorted = [...(withinLimit.length ? withinLimit : mp4)].sort((a, b) => b.width - a.width);
        const source = sorted[0] ? { ...sorted[0], url: new URL(sorted[0].url, document.baseURI).href } : null;
        if (source?.url === this.source?.url) return;
        this.source = source;
        this.failed = false;
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.load();
        this.removeAttribute('data-ready');
        this.setPlaying(false);
        this.button.hidden = !source;
        this.sync();
      }

      sync() {
        if (!this.visible || document.hidden || this.userPaused || (!this.manual && (!this.auto || this.reduced.matches || navigator.connection?.saveData))) {
          this.video.pause();
          return;
        }
        this.start();
      }

      start() {
        if (!this.source || this.failed) return;
        if (this.video.getAttribute('src') !== this.source.url) this.video.src = this.source.url;
        const activeSource = this.source;
        this.video.play().catch(() => {
          if (this.source === activeSource && this.video.paused) this.setPlaying(false);
        });
      }

      setPlaying(playing) {
        this.toggleAttribute('data-playing', playing);
        this.button.setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.video?.pause();
        this.video?.removeAttribute('src');
        this.video?.load();
        this.source = null;
        this.removeAttribute('data-ready');
        this.removeAttribute('data-playing');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {
    // Look for an element with class 'related-products'
    var productRecommendationsSection = document.querySelector(".related-products");
    if (productRecommendationsSection === null) { return; }
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", productRecommendationsSection.dataset.url);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
      }
    };
    request.send();
  };
  // fetch when section reloads in editor
  document.addEventListener("shopify:section:load", function(event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
      loadProductRecommendationsIntoSection();
    }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
